// extracted by mini-css-extract-plugin
export default {"FooterContainer":"Footer_FooterContainer__lBgOH","LogoIcon":"Footer_LogoIcon__R3LlX","Icon":"Footer_Icon__bUZy+"};